<template>
  <v-card flat>
    <v-card-title class="subheader py-0">
      <v-icon small class="mr-1" color="teal">group</v-icon>
      专家管理
      <v-spacer/>
      <v-btn flat round color="primary" dark
             :disabled = deleDisna
             @click.native.stop="
             () => {
                  editDbid = null;
                  reviewId = review? review.dbid: null;
                  editExpert = true;
                }">
        <v-icon>add</v-icon>
        添加评审专家
      </v-btn>

    </v-card-title>

    <v-divider color="teal" />

    <v-card-text class="pt-0">
      <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          class="elevation-0 dense"
          no-data-text="没有数据。"
      >
        <template slot="items" slot-scope="props">
            <td>{{ props.item.rank}}</td>
            <td>{{ props.item.name }} {{ props.item.title.name ? props.item.title.name : ''}}</td>
            <td>{{ props.item.institution}}</td>
          <td>
            <span>{{ props.item.areaex? props.item.areaex.map(a => `${a.name}`).join(',') : ''}}<br/>
              {{ props.item.direction? props.item.direction.map(a => `${a.name}`).join(',') : ''}}
            </span>
          </td>
          <td class="justify-center layout px-0">
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     @click="
                         () => {
                            viewDbid = props.item.dbid; view = true;
                         }">
                <v-icon color="teal">more_horiz</v-icon>
              </v-btn>
              <span>查看</span>
            </v-tooltip>

            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     :disabled = deleDisna
                     @click="
                     () => {
                        deleDbid = props.item.dbid;
                        deleMsg = `${props.item.name} / ${props.item.institution || ''}`;
                        dele = true;
                     }">
                <v-icon color="pink">delete_forever</v-icon>
              </v-btn>
              <span>删除</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </v-card-text>

    <x-view
        v-model="view"
        :dbid="viewDbid"
    />

    <x-edit
        v-model="editExpert"
        :dbid="editDbid"
        :review-id=reviewId
        :expert="items"
        v-on:ok="onEditOk"
    />

    <x-delete
        v-model="dele"
        :message="deleMsg"
        :uri="uri"
        :dbid="deleDbid"
        v-on:ok="onDeleOk"
    />

  </v-card>
</template>

<script>
import XEdit from '@/components/proj/review/Expert/Edit';
import XView from './ViewExpert';
import XDelete from '@/components/global/Delete';
const baseURI = '/api/proj/review-expert';
export default {
  name: "Expert",
  components: {XEdit, XDelete, XView},
  props: {
    review: Object
  },
  data: () => ({
    uri: baseURI,

    editExpert: false,
    editDbid: null,
    reviewId: null,

    headers: [
      {
        text: '#',
        sortable: false,
        value: 'dbid',
        width: '20'
      },
      {text: '姓名/职称/工号', value: 'name', sortable: false},
      {text: '工作单位', value: 'institution', sortable: false},
      {text: '研究领域/方向', value: 'area', sortable: false},
      {text: '操作', value: 'dbid', sortable: false, align: 'center', width: 60}

    ],

    items: [],

    dele: false,
    deleDbid: null,
    deleMsg: null,
    deleDisna: false,

    view: false,
    viewDbid: null,

  }),
  watch: {
    review(p) {
      if(p.status.identifier === "review"  || p.status.identifier === "finish" || p.status.identifier === "pubed" || p.status.identifier === "unpub" || p.status.identifier === "recieve")
      {
        //如果申报处于评审或结束状态，则申报专家不可以再修改
        this.deleDisna = true
      }
      this.axios
          .get(`${baseURI}?reviewId=${p.dbid}`)
          .then(
              rsp =>
              {
                this.items = rsp.data.items
              }
          )
    }
  },
  methods: {
    onEditOk(item) {
      //console.log("in Income onEditOK");
      if (item) {
        if (!this.editDbid) {
          this.items.unshift(item);
        } else {
          const editIdx = this.items.findIndex((v) => v.dbid === item.dbid);
          this.items[editIdx] = window.xutil.clone(item);
        }
        this.items = this.items.sort((a, b) => a.rank >= b.rank);
      }
    },
    onDeleOk(item) {
      if (item) {
        const deleIdx = this.items.findIndex((v) => v.dbid === item.dbid);
        this.items.splice(deleIdx, 1);
      }
    },
  },
}
</script>

<style scoped>

</style>